// covered-by: frontends/carrie/src/routes/settings/routes/knowledge-database/components/__tests__/CitationInlinePreview.test.tsx
import { forwardRef } from "react";

import { toCssPercent } from "./rotationUtils";

import {
  useCommittedSourcePin,
  useSourcePinGesture,
} from "../utils/sourcePinMove";

// The same disc the knowledge source used when it was centred on the point.
const SOURCE_PIN_DOT_CLASS =
  "border-white bg-blue-9 absolute block size-4 -translate-x-1/2 -translate-y-1/2 cursor-grab touch-none rounded-full border-2 border-solid shadow-md";

/**
 * Knowledge-source dot. It stays on the stored point until the reader drags
 * it; the drop is what is drawn after that.
 */
export const SourcePinDot = forwardRef<
  HTMLSpanElement,
  {
    relX: number;
    relY: number;
    "aria-label": string;
    "data-testid": string;
  }
>(function SourcePinDot(
  { relX, relY, "aria-label": ariaLabel, "data-testid": testId },
  ref,
) {
  const { drawn, commit } = useCommittedSourcePin({ relX, relY });
  const gesture = useSourcePinGesture({
    relX: drawn.relX,
    relY: drawn.relY,
    rotation: 0,
    onCommit: commit,
  });

  return (
    <span
      ref={ref}
      aria-label={ariaLabel}
      className={SOURCE_PIN_DOT_CLASS}
      style={{ left: toCssPercent(drawn.relX), top: toCssPercent(drawn.relY) }}
      data-testid={testId}
      onPointerDown={gesture.onPointerDown}
      onPointerMove={gesture.onPointerMove}
      onPointerUp={gesture.onPointerUp}
      onPointerCancel={gesture.onPointerCancel}
    />
  );
});
